import * as XLSX from 'xlsx'
import { commonMethods } from './commonMethods'

export const formatDateForFileName = (date) => {
  const day = String(date.getDate()).padStart(2, '0')
  const month = date.toLocaleString('default', { month: 'long' })
  const year = date.getFullYear()

  return `${day}-${month}-${year}`
}
export const exportReportToExcel = (data, columns, isColumnVisible, options = {}) => {
  const { sheetName = 'Report', fileNamePrefix = 'report', getDateFromItem } = options

  if (!data?.length) return

  const activeColumns = columns.filter((col) => col.dataField && isColumnVisible(col))

  const rowsToExport = data.map((item) => {
    const row = {}

    activeColumns.forEach((col) => {
      row[col.text] = item[col.dataField]
    })

    return row
  })

  const workbook = XLSX.utils.book_new()
  const worksheet = XLSX.utils.json_to_sheet(rowsToExport)

  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName)

  let fileName = fileNamePrefix

  if (typeof getDateFromItem === 'function') {
    const datesList = data
      .map((item) => {
        const d = getDateFromItem(item)

        if (!d) return null
        if (d instanceof Date) return Number(d) ? d : null
        const parsed = commonMethods.parseCustomDateFormat(d)

        return parsed && Number(parsed) ? parsed : null
      })
      .filter(Boolean)

    if (datesList.length > 0) {
      const minDate = new Date(Math.min(...datesList))
      const maxDate = new Date(Math.max(...datesList))
      const start = formatDateForFileName(minDate)
      const end = formatDateForFileName(maxDate)

      fileName += `__${start}_to_${end}`
    }
  }

  fileName += '.xlsx'

  XLSX.writeFile(workbook, fileName)
}
